import { Drawer, Stack } from '@mantine/core';
import { Text } from '@repo/foundations';
import { useAutomationJob } from '../../api/hooks/automationJob';
import type { AutomationJob } from '../../api/types/models/automation/automationJob';
import { DateRenderer } from '../CatalogView/TableView/DateRenderer.tsx';
import { ErrorLogs } from '../ErrorLogs/ErrorLogs';
import { AutomationHistoryDetailsTable } from './AutomationHistoryDetailTable';
import { AutomationRunStatusBadge } from './AutomationRunStatusBadge.tsx';

interface IAutomationJobDrawerProps {
	automationJob: AutomationJob;
	opened: boolean;
	onClose: () => void;
}

export function AutomationJobDrawer({
	automationJob,
	opened,
	onClose,
}: IAutomationJobDrawerProps) {
	const rolledBackJob = useAutomationJob({
		id: automationJob.job_rolled_back ?? '',
		options: {
			enabled:
				!!automationJob.is_rollback &&
				!automationJob.error_message &&
				!!automationJob.job_rolled_back,
		},
	});

	return (
		<Drawer
			opened={opened}
			onClose={onClose}
			position="right"
			title={
				<Text size="md" weight="bold">
					Status
				</Text>
			}
		>
			<Stack w="100%">
				<Text size="sm" weight="regular">
					<AutomationRunStatusBadge status={automationJob.status} />
				</Text>
				{automationJob.error_message && (
					<ErrorLogs title="Error" logs={[automationJob.error_message]} />
				)}
				{rolledBackJob && rolledBackJob.isSuccess && rolledBackJob.data && (
					<Text size={'md'}>
						Successfully rolled back changes to job executed at{' '}
						<DateRenderer size={'md'} value={rolledBackJob.data.started_at} />
					</Text>
				)}
				{!automationJob.error_message && (
					<AutomationHistoryDetailsTable automationJobId={automationJob.id} />
				)}
			</Stack>
		</Drawer>
	);
}
